<template>
  <div class="lad-filter--price-content">
    <slot name="before-range" />

    <el-radio-group slot="before-range" v-model="filterBy" size="mini">
      <el-radio-button v-for="v in options" :key="v" :label="v" :value="v">{{
        $t(`${base}.options.${v}`)
      }}</el-radio-button>
    </el-radio-group>

    <div class="wrapper-element-filter">
      <el-slider
        v-model="privateValues"
        range
        :show-tooltip="false"
        :min="min"
        :max="max"
        :step="currentPow"
      />
      <div class="wrapper-min-max-labels">
        <span class="value-min">{{ firstValue | ladFnCurrency }}</span>
        <span class="value-max">{{ lastValue | ladFnCurrency }}</span>
      </div>
    </div>

    <slot name="buttons" />
  </div>
</template>

<script>
import PriceMixin from '@/components/search/mixin/price'

export default {
  name: 'LadFilterPriceRange',
  mixins: [PriceMixin],
  props: {
    value: {
      type: Object,
      default: () => ({ min: null, max: null, type: 'price' }),
      required: true,
    },
  },
  data() {
    return {
      base: 'filters.price',
      privateValues: [],
    }
  },
  computed: {
    firstValue() {
      return Math.max(this.min, this.value.min || this.min)
    },
    lastValue() {
      return Math.min(this.max, this.value.max || this.max)
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler({ min, max, type }) {
        this.privateValues = [min || this.min, max || this.max]
        this.filterBy = type
      },
    },
    filterBy(newValue) {
      if (this.value.type !== newValue) {
        this.$emit('update-values', {
          min:
            this.firstValue === this.min
              ? this.min
              : Math.max(this.privateValues[0], this.min),
          max:
            this.lastValue === this.max
              ? this.max
              : Math.min(this.privateValues[1], this.max),
          type: newValue,
        })
      }
    },
    privateValues(newValue) {
      if (this.value.min !== newValue[0] || this.value.max !== newValue[1]) {
        this.$emit('update-values', {
          min: newValue[0],
          max: newValue[1],
          type: this.filterBy,
        })
      }
    },
  },
}
</script>

<style lang="scss">
.lad-filter--price-content {
  /** */
}
</style>
